<template>
  <div
    :class="'liked-box animate__animated ' + animateClass + ' animate__faster'"
    ref="dropdown"
  >
    <span class="liked-box__close icon-close" @click="close"></span>
    <swiper-list
      title="Liked Videos"
      :items="liked"
      bgColor="transparent"
      @swiperItem_clicked="close"
    />
    <div v-if="!liked || (liked && liked.length == 0)">
      <p>
        You have not put a like on any video yet. You can add a like to a video
        in the video page, just click on the thumb icon.
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SwiperList from "@/components/home/SwiperList.vue";

export default {
  name: "LikedBox",
  components: {
    SwiperList,
  },
  data() {
    return {
      animateClass: "animate__slideInDown",
    };
  },
  mounted() {
    this.fetchLiked();
    // add class to body to prevent scrolling
    setTimeout(() => document.body.classList.add("noscroll"), 500);
  },
  updated() {
    window.addEventListener("click", this.closeDropdown);
  },
  computed: {
    ...mapGetters("videos", ["liked"]),
  },
  methods: {
    ...mapActions("videos", ["setIsLikedOpen", "fetchLiked"]),
    close() {
      // remove class from body to allow scrolling
      document.body.classList.remove("noscroll");

      this.animateClass = "animate__slideOutUp";
      setTimeout(() => this.setIsLikedOpen(false), 800);
    },
    closeDropdown(e) {
      if (!this.$refs.dropdown.contains(e.target)) {
        this.close();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("click", this.closeDropdown);
  },
};
</script>

<style lang="scss" scoped>
@import "bulma/sass/utilities/mixins.sass";

.liked-box {
  // position and layout
  position: fixed;
  z-index: 1;
  top: 104px;
  right: 0;
  left: 0;
  min-height: 50vh;
  margin: 0 10px 0 10px;

  // display and visibility
  row-gap: 16px;

  // box model
  padding: 10px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;

  // background
  background-color: #ffffffbb;
  backdrop-filter: blur(8px);

  &__close {
    // position and layout
    position: absolute;
    top: 15px;
    right: 15px;

    // typography
    font-size: 0.8rem;
    color: black;

    // background
    cursor: pointer;
  }
}
</style>
